import OrdersService from '@/services/resources/orders.service';
import statesMixin from './statesMixin';
import { mapState, mapGetters } from 'vuex';

export default {
  mixins: [statesMixin],
  computed: {
    ...mapState('models/order', ['states']),

    ...mapGetters('models/order', { getOrderStateByName: 'getStateByName' }),

    isOrderPending() {
      return this.checkStatus(OrdersService._STATE_PENDING);
    },
    isOrderOpen() {
      return this.checkStatus(OrdersService._STATE_OPEN);
    },
    isOrderAccepted() {
      return this.checkStatus(OrdersService._STATE_ACCEPTED);
    },
  },
  mounted() {
    this.statesColors = this.$services.resource('order_states').getColors();
  },
  data() {
    return {
      statesColors: [],
    };
  },
  methods: {
    getColor(order) {
      return this.statesColors[order.state.id - 1];
    },
    checkStatus(status) {
      return this.order.state && this.order.state.name === status;
    },
    setNewState(state) {
      // must define order object inside data
      this.order.state = state;
    },
  },
};
